import { IBreadcrumbItem, PivotItem } from '@fluentui/react';
import {
  PageHeader,
  pageHeaderStylesSecondary,
  Pivot,
  pivotContainerStylesFill,
  pivotStylesFill,
  useClassNames,
} from '@h2oai/ui-kit';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { AccessRequestList } from '../../../components/AccessRequestList/AccessRequestList';
import { PermissionState } from '../../../featurestore/gen/ai/h2o/featurestore/api/v1/CoreService.pb';
import { ContentsTitle } from '../../../featurestore/models';
import { featurestorePageClassName } from '../../../featurestore/styles';
import { useSearchParams } from '../../../utils/hooks';
import { accessControlStylesDefault, IAccessControlClassNames, IAccessControlStyles } from './AccessControl.styles';

const getBreadcrumbItems = (pageTitle: ContentsTitle, currentTitle = ContentsTitle.managePermissions) => {
  return [
    { text: ContentsTitle.accessControl, key: ContentsTitle.accessControl },
    { text: pageTitle, key: pageTitle },
    {
      text: currentTitle,
      key: currentTitle,
      isCurrentItem: true,
    },
  ];
};

const getPivotItems = (title: ContentsTitle, filter?: PermissionState) => {
  return [
    {
      key: ContentsTitle.managePermissions,
      headerText: ContentsTitle.managePermissions,
      iconName: 'Clock',
      content: (
        <AccessRequestList
          title={title}
          subTitle={ContentsTitle.managePermissions}
          filters={filter ? [filter] : undefined}
        />
      ),
    },
    {
      key: ContentsTitle.myPermissions,
      headerText: ContentsTitle.myPermissions,
      iconName: 'Permissions',
      content: (
        <AccessRequestList
          title={title}
          subTitle={ContentsTitle.myPermissions}
          filters={filter ? [filter] : undefined}
        />
      ),
    },
  ];
};

interface IAccessContolProps {
  title: ContentsTitle;
}

export const AccessControl = ({ title }: IAccessContolProps) => {
  const location = useLocation();
  const [params, setParams] = useSearchParams();
  const tab = params.get('tab');
  const filter = params.get('filter');
  const [selectedPivotKey, setSelectedPivotKey] = useState(tab ? tab : ContentsTitle.managePermissions);
  const [breadcrumbItems, setBreadcrumbItems] = useState<IBreadcrumbItem[]>(getBreadcrumbItems(title));
  useEffect(() => {
    setBreadcrumbItems(getBreadcrumbItems(title));
    if (tab) {
      setSelectedPivotKey(tab);
    }
  }, [title, location.pathname]);
  const classNames = useClassNames<IAccessControlStyles, IAccessControlClassNames>(
    'AccessControl',
    accessControlStylesDefault,
    undefined,
    featurestorePageClassName
  );
  return (
    <div className={classNames.root} data-test="access-control">
      <PageHeader
        styles={pageHeaderStylesSecondary}
        pageTitle={title}
        style={{ marginBottom: 16 }}
        breadcrumbProps={{
          items: breadcrumbItems,
        }}
      />
      <Pivot
        styles={pivotStylesFill}
        pivotContainerStyles={pivotContainerStylesFill}
        selectedKey={selectedPivotKey}
        onLinkClick={(item?: PivotItem) => {
          const contentsTitle = item?.props.itemKey as ContentsTitle;
          if (contentsTitle) {
            setBreadcrumbItems(getBreadcrumbItems(title, contentsTitle));
            setSelectedPivotKey(contentsTitle);
            params.set('tab', contentsTitle);
            setParams(params);
          }
        }}
        items={getPivotItems(title, filter as PermissionState)}
      />
    </div>
  );
};
